module.exports = __webpack_public_path__ + "static/img/y-3.d9987538.png";